<script setup lang="ts">
import { cn } from '@/lib/utils.ts';
import { NavigationMenuList, type NavigationMenuListProps, useForwardProps } from 'radix-vue';
import { type HTMLAttributes, computed } from 'vue';

const props = defineProps<NavigationMenuListProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <NavigationMenuList
    v-bind="forwardedProps"
    class="nav-list"
    :class="cn('group flex flex-1 list-none items-center justify-center', props.class)"
  >
    <slot />
  </NavigationMenuList>
</template>
